import React, { ReactElement } from "react";

export default function AuthLoading(): ReactElement {
  return <div>Auth Loading</div>;
}
